var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableConfigDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 88,
    viewBox: "0 0 145 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17773 22.4375V42.0912C9.17773 44.0242 10.7447 45.5912 12.6777 45.5912H18.1777V46.5912H12.6777C10.1925 46.5912 8.17773 44.5765 8.17773 42.0912V22.4375H9.17773Z",
    stroke: "#EDEEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17773 40.5898V78.0898C9.17773 80.0228 10.7447 81.5898 12.6777 81.5898H18.1777V82.5898H12.6777C10.1925 82.5898 8.17773 80.5751 8.17773 78.0898V40.5898H9.17773Z",
    stroke: "#EDEEF2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.0854,
    y: 39.707,
    width: 118.914,
    height: 12.3828,
    rx: 2,
    fill: "#5D5FEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0854,
    y: 74.707,
    width: 118.914,
    height: 12.3828,
    rx: 2,
    fill: "#EDEEF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.168457,
    width: 17.1406,
    height: 17.1406,
    rx: 4.28599,
    fill: "#EDEEF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableConfigDefault);
export default __webpack_public_path__ + "static/media/TableConfigDefault.3e669d02bb2e0e5f887eada25dfa149a.svg";
export { ForwardRef as ReactComponent };